import { combineReducers } from 'redux'
import userInfo from './userInfo'
import appType from './appType'
import departmentList from './department'

export default combineReducers({
    userInfo,
    appType,
    departmentList
})